import { defineStore } from 'pinia';
import { API } from '@/api/api';
import type { Modals } from '~/interfaces/app';

export const useModalsStore = defineStore('modals', () => {
  // STATES
  const ids = ref<string | number[]>([]);
  const modals = ref<Modals[]>([]);

  const get = computed(() =>
    Object.fromEntries(modals.value.map((modal) => [modal?.name, modal.data]))
  );

  function setData(modal: Modals) {
    modals.value.push(modal);
  }

  function close(name: String) {
    modals.value = modals.value.filter((modal) => modal?.name !== name);
  }

  function clear() {
    modals.value = [];
  }

  function update(modal: Modals) {
    const modalIndex = modals.value.findIndex((m) => m?.name === modal.name);
    modals.value = [
      ...modals.value.slice(0, modalIndex),
      modal,
      ...modals.value.slice(modalIndex + 1),
    ];
  }

  async function initPromo(coupon: string) {
    return await API.get(`coupons/${coupon}`)
      .then((res) => {
        update({
          name: 'ModelPromo',
          data: { ...res.data },
        });
        return res;
      })
      .catch(() => {});
  }

  return {
    ids,
    setData,
    update,
    close,
    get,
    clear,
    initPromo,
  };
});
